<!-- Loading -->
<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<section class="content-header compact-header">
  <div class="container-fluid">

    <div class="header-row">
      <a routerLink="/" class="toolbar-btn">
        <i class="fas fa-home"></i>
      </a>

      <h5 class="page-title mb-0">
        Upload Photos
      </h5>

      <button class="toolbar-btn" disabled>
        <i class="fas fa-car"></i>
      </button>
    </div>

  </div>
</section>
<!-- /.content-header -->
<section class="content">
  <div class="container-fluid">
    <div class="card shadow-sm rounded-lg">
      <!-- Header -->
      <div class="card-header">
        <h5 class="mb-0 text-danger font-weight-bold">
          Upload Photos for {{ chassisNo }}
        </h5>
      </div>

      <div class="card-body">
        <div class="col-12">
          <form (ngSubmit)="handleSubmit()">
            <ngx-dropzone (change)="onSelect($event)">
                <ngx-dropzone-label>Tap to upload photos!</ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-image-preview>
            </ngx-dropzone>

            <div class="mt-4" >
                <button class="btn btn-success" type="button" *ngIf="isUploading; else showUploadBtn" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Uploading...
                </button>

                <ng-template #showUploadBtn>
                    <button type="submit" class="btn btn-success rounded-pill upload-btn"><i class="fas fa-upload fa-sm" aria-hidden="true">&nbsp;</i>Upload</button>
                </ng-template>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
